export default __webpack_public_path__ + "static/media/unstructured_logo.2fd1e2c8.png";